import ReactPaginate from 'react-paginate';
import { oneLine } from 'common-tags';

import ChevronLeft from '@/icons/light/chevron-left.svg';
import ChevronRight from '@/icons/light/chevron-right.svg';

import { generatedPaginationStyle } from '@/lib/contexts/pagination-style.generated';

import type { FunctionComponent } from 'react';
import type { TypePaginationProps } from './types';

// Tenant elige preset vía `paginationStyle` en ThemeConfiguration:
//   `legacy`  — histórico (40×40, rounded, gap 12).
//   `compact` — Figma HoM (24×24 pill, gap 8/12, texto blanco en activo).
const PRESETS = {
  legacy: {
    page: 'flex flex-row gap-3 items-center justify-center p-1 text-center h-10 w-10 text-body text-body-l cursor-pointer [&_a]:cursor-pointer [&_a]:text-text-neutrals-900',
    active:
      'flex flex-row gap-3 items-center bg-secondary-500 rounded-custom text-secondary-900 text-body text-body-l cursor-pointer',
    root: 'flex flex-row items-center gap-3',
  },
  compact: {
    page: 'flex items-center justify-center text-center h-6 w-6 text-base font-bold cursor-pointer [&_a]:cursor-pointer [&_a]:text-text-neutrals-900',
    active: 'bg-secondary-500 rounded-full [&_a]:text-white!',
    root: 'flex flex-row items-center gap-2 [&_li.previous]:mr-3 [&_li.next]:ml-3',
  },
} as const;

const preset = PRESETS[generatedPaginationStyle];

export const Pagination: FunctionComponent<TypePaginationProps> = ({
  className = '',
  disabled = false,
  onPageChange,
  pageRangeDisplayed = 2,
  pageCount,
  renderOnZeroPageCount = () => null,
}: TypePaginationProps) => (
  <ReactPaginate
    previousLabel={
      <ChevronLeft
        width={24}
        height={24}
        className="text-neutrals-900 flex flex-row items-center gap-3"
      />
    }
    nextLabel={
      <ChevronRight
        width={24}
        height={24}
        className="text-neutrals-900 flex flex-row items-center gap-3"
      />
    }
    pageClassName={preset.page}
    activeClassName={preset.active}
    disabledClassName="pointer-events-none text-neutrals-300 opacity-40"
    onPageChange={onPageChange}
    pageRangeDisplayed={pageRangeDisplayed}
    pageCount={pageCount}
    renderOnZeroPageCount={renderOnZeroPageCount}
    marginPagesDisplayed={0}
    breakLabel={null}
    className={oneLine`${preset.root} [&_li.next]:cursor-pointer [&_li.next_a]:cursor-pointer [&_li.previous]:cursor-pointer [&_li.previous_a]:cursor-pointer ${disabled ? 'pointer-events-none opacity-40' : ''} ${className} `}
  />
);

Pagination.displayName = 'Pagination';
